import { Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { formatCurrency, formatDate } from '../../generalFunctions';
import Signature from './common/Signature';
import logo from "../../assests/images/LuktukeLogo.png";
import { PDF_ALL_MARGIN, PDF_LEFT_MARGIN, PDF_RIGHT_MARGIN } from '../../constants';

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        padding: 10
    },
    detailColumn: {
        flexDirection: 'column',
        flexGrow: 15,
    },
    linkColumn: {
        flexDirection: 'column',
        flexGrow: 2,
        alignSelf: 'flex-end',
        justifySelf: 'flex-end',
    },
    title: {
        fontSize: 10,
        fontWeight: "bold",
        borderStyle: "solid",
        borderColor: "black",
        borderWidth: 2,
        maxWidth: 160,
        textAlign: "left",
        padding: 10,
        marginBottom: 1
    },
    subtitle: {
        flexDirection: "column",
        flexGrow: 2,
        fontSize: 7,
        marginBottom: 1
    },
    image: {
        alignSelf: "flex-start",
        width: 130,
        height: 80
    },
    ronumber: {
        flexDirection: "column",
        //flexGrow: 1,
        fontSize: 10,
        fontWeight: "bold",
        //marginLeft: 3,
    }
});

const OnAccountPdf = (props) => {
    return (
        <Page style={{ paddingLeft: PDF_LEFT_MARGIN, margin: PDF_ALL_MARGIN, paddingRight: PDF_RIGHT_MARGIN }} id={props.data.id} size="A4">
            <View style={{ border: 2, padding: 5 }}>
                <View style={styles.container}>
                    <View style={styles.detailColumn}>
                        <View>
                            <Text style={{ alignSelf: "flex-start", fontFamily: "ARLRDBD", fontSize: 13 }} >{"PAYMENT VOUCHER" + ` (${props.data.voucherType})`}</Text>
                        </View>
                        <View style={{ flexDirection: "row", marginTop: 4 }}>
                            <Text style={{ fontSize: 10, fontWeight: "bold" }}>Date: </Text>
                            <Text style={{ fontSize: 10 }}>{formatDate(props.data.paymentDate)}</Text>
                        </View>
                        <View style={{ flexDirection: "row", marginTop: 4 }}>
                            <Text style={{ fontSize: 10, fontWeight: "bold" }}>Voucher No. </Text>
                            <Text style={{ fontSize: 10 }}>{props.data.id}</Text>
                        </View>
                        <View style={{ flexDirection: "row", marginTop: 4 }}>
                            <Text style={{ fontSize: 10 }}>To,</Text>
                        </View>
                        <View style={{ flexDirection: "row", marginTop: 2, width: 200 }}>
                            <Text style={{ fontSize: 10, fontWeight: "bold" }}>{props.data.accountName}</Text>
                        </View>
                    </View>
                    <View style={styles.linkColumn}>
                        <Image
                            src={logo}
                            style={styles.image}
                        />
                    </View>
                </View>

                <View style={{ flexDirection: "row", padding: 10, marginBottom: 5 }}>
                    <Text style={{
                        fontSize: 10,
                        flexDirection: "column",
                        marginRight: 20,
                        flexGrow: 1,
                        lineHeight: 2
                    }}>
                        {`We have sent Rs. ${formatCurrency(props.data.amount)} only through ${props.data.voucherType} in your A/C towards the payment of ${props.data.narration}`}
                    </Text>
                </View>

                <View style={{ flexDirection: "row", padding: 10 }}>
                    <View style={{ flexDirection: "column", width: "50%", alignItems: "flex-start" }}>
                        <Text style={{
                            fontSize: 12,
                            alignSelf: "flex-start",
                            border: 1,
                            padding: 8,
                            maxWidth: 100
                        }}>Rs. {formatCurrency(props.data.amount)}</Text>
                    </View>
                    <View style={{ flexDirection: "column", width: "50%", alignItems: "flex-end" }}>
                        <Signature />
                    </View>
                </View>
            </View>
        </Page>
    );
}

export default OnAccountPdf;